export default __webpack_public_path__ + "static/media/0xe06bd4f5aac8d0aa337d13ec88db6defc6eaeefe.32bec8b0.webp";